import {bus} from '../../main';
import random from 'random';

export default {
   data() {
      return {
         swap: {
            upload_title: '',
         },
         timer: {
            max: 100,
            speed: 1000,
            counter: '',
            counterString: '',
            timerInterval: null
         },
      }
   },
   methods: {
      setCounter() {
         this.timer.counter += random.int(1, 2);
         this.timer.counterString = `width: ${this.timer.counter}%;`;
      },
      resetUpload() {
         if (this.$refs['upload_container']) {
            let doc = this.$refs['upload_container'];
            doc.style = 'display: none';
            let el2 = doc.querySelector('.progress-bar');
            let el3 = doc.querySelector('.peecent-state--Wrapper');
            if (el2 && el3) {
               el2.style = `width: 0%;`;
               el3.innerText = `0%`;
            }
         }
      },
      startUploading() {
         this.resetUpload();
         let doc = this.$refs['upload_container'];
         doc.style = 'display: block';
         let el0 = doc.querySelector('.progress-compile-iconWrapper');
         let el1 = doc.querySelector('.progress-compile-percent');
         let el2 = doc.querySelector('.progress-bar');
         let el3 = doc.querySelector('.peecent-state--Wrapper');
         this.timer.timerInterval = setInterval(() => {
            this.setCounter();
            if (this.timer.counter >= 60) {
               el0.childNodes[0].classList.remove('progress-compile-icon-fade');
               el0.childNodes[0].classList.add('progress-compile-icon');
               el1.classList.add('disabled');
               el2.classList.remove('bg-faded');
               el2.classList.add('bg-success');
            }
            el2.style = `width: ${this.timer.counter}%;`;
            el3.innerText = `${this.timer.counter}% Uploading...`;
            if (this.timer.counter >= this.timer.max) {
               this.stopCounter(el3);
               setTimeout(() => {
                  bus.$emit('emit_done_uploading');
               }, 1000);
            }
         }, this.timer.speed);
      },
      stopCounter(el3) {
         this.timer.counter = this.timer.max;
         this.timer.counterString = 'width: 100%;';
         el3.innerText = `Done`;
         clearInterval(this.timer.timerInterval);
      },
   }
}